import { gql } from '@apollo/client';

export const updateScribeNote = gql`
  mutation UpdateScribeNote($note: String!, $scribeNoteId: String!) {
    updateScribeNote(note: $note, scribeNoteId: $scribeNoteId)
  }
`;
